var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-sans text-gray-900 antialiased"})}
var staticRenderFns = []

export { render, staticRenderFns }